import React from "react";
import "./section.css";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { toggleCheck } from "../../../store/slices/pvi_checklist.slices";
import { PVI_CHECKLIST } from "../../../incpection.com/data/pvi_data";

const PVICheckList = () => {
  const dispatch = useDispatch();

  // flat redux state: { key: value }
  const checklistValues = useSelector((state) => state.pvi_list);

  const handleCheck = (key) => {
    dispatch(toggleCheck(key));
  };

  const renderStatus = (checked) => {
    if (checked === true) return <span>✓</span>;
    if (checked === false) return <span>✗</span>;
    return <span>—</span>;
  };

  return (
    <Box className="pvInstallationList">
      <Typography variant="h6" gutterBottom fontWeight="bold">
        PV System Installation Checklist
      </Typography>

      <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell sx={{ fontWeight: "bold" }}>Inspection Item</TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold", width: 120 }}>
                Status
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {PVI_CHECKLIST.map((item) => (
              <TableRow key={item.key}>
                <TableCell
                  sx={{
                    fontWeight: "bold",
                    padding: "12px 16px",
                    fontSize: "0.95rem",
                  }}
                >
                  {item.label}
                </TableCell>

                <TableCell
                  align="center"
                  onClick={() => handleCheck(item.key)}
                  sx={{
                    cursor: "pointer",
                    fontSize: "1.2rem",
                    userSelect: "none",
                    fontWeight: 600,
                    color: "gray",
                  }}
                >
                  {renderStatus(checklistValues[item.key])}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default PVICheckList;
